<template>
  <div>
    <!-- 我的收藏 -->
    <div action="" class="w-100 layui-form" method="post">
      <div class="user-info3 w-100 between-center">
        <!-- <el-date-picker v-model="date" type="daterange" range-separator="——" start-placeholder="开始日期"
					end-placeholder="结束日期">
				</el-date-picker> -->
        <el-input placeholder="产品名称" v-model="productName"  @keyup.enter.native.stop="searchGoods"></el-input>
        <div class="btns">
          <!-- <input
            class="layui-btn layui-btn-normal"
            name=""
            id=""
            value="确定"
            @click="searchGoods"
          /> -->
          <div
            class="layui-btn layui-btn-normal"
            name=""
            id=""
            value="确定"
            @click="searchGoods"
          >确定</div>
          <input
            type="reset"
            class="layui-btn"
            name=""
            id=""
            value="重置"
            @click="reset"
          />
        </div>
      </div>
    </div>
    <div style="overflow-y: scroll;max-height: 580px;width: 100%;">
      <div
        class="no-content"
        style="display: flex;justify-content: center;"
        v-if="list.length == 0"
      >
        <img src="/static/img/no_data5.png" />
      </div>
      <table
        class="table table-hover w-100"
        v-else
        style="table-layout: fixed;"
      >
        <tr>
          <th width=""><label class="checkbox-inline">产品名称</label></th>
          <th width="15%">产品规格</th>
          <th width="22%">收藏时间</th>
          <th width="22%">操作</th>
        </tr>
        <template v-for="(item, index) in list">
          <tr :key="index">
            <td>
              <div class="sp-info">
                <input
                  type="checkbox"
                  :checked="item.checked"
                  class="checkbox-style sonCheckbox"
                  name=""
                  id=""
                  :value="index"
                  @change="checkedOne(item)"
                />
                <div
                  class="between-center"
                  style="justify-content: flex-start;"
                  @click="clickDetails(item, 1)"
                >
                  <img
                    :src="item.eshopGdGoodsTbl.coverUrl"
                    style="cursor: pointer;"
                  />
                  <div style="cursor: pointer;">
                    <span>{{ item.eshopGdGoodsTbl.name }}</span>
                  </div>
                </div>
              </div>
            </td>
            <td>{{ item.eshopGdGoodsTbl.modelNumber }}</td>
            <td>{{ item.whenCreated }}</td>
            <td>
              <div class="sp-btn">
                <a href="javascript:;" @click="deleteItem(item)">删除</a>
                <!-- <a href="javascript:;" @click="addCart(item)">添加购物车</a> -->
              </div>
            </td>
          </tr>
        </template>
      </table>
    </div>
    <div class="user-info4 w-100 between-center" v-if="list.length != 0">
      <div class="f-l between-center">
        <label class="checkbox-inline"
          ><input
            type="checkbox"
            class="checkbox-style allCheckbox"
            name=""
            id=""
            value=""
            :checked="allCheck"
            @click="checkedAll"
          />&nbsp;</label
        >
        <span @click="allDelCllect">删除所选</span>
      </div>
      <div class="f-r between-center">
        <span
          >已选择<i>{{ goodsId.length }}</i
          >件商品</span
        >
        <!-- <a href="">去报价</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCollection,
  addCart,
  getCategories,
  goodsCollection
} from "@/common/http.js";
import { message } from "@/common/common.js";
export default {
  data() {
    return {
      date: "",
      productName: "",
      userInfo: {},
      list: [],
      goodsId: [],
      allCheck: false,
      categorys: []
    };
  },
  mounted() {
    this.$emit("change_bread", 6);
    if (localStorage.getItem("userInfo")) {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.getCollect();
    } else {
      // this.$alert('这是一段内容', '提示', {
      // 	confirmButtonText: '确定',
      // 	callback: action => {
      // 		this.$message({
      // 			type: 'info',
      // 			message: `action: ${action}`
      // 		});
      // 	}
      // });
    }
    this.initCategory();
  },
  methods: {
    searchGoods() {
      this.getCollect();
    },
    initCategory() {
      getCategories({
        // homeCategoryId: 15,
        // isChildren: 1,
        type: 1
      }).then(res => {
        if (res.result) {
          this.categorys = res.data;
        }
      });
    },
    getCollect() {
      getCollection({
        pageSize: 99999,
        pageNo: 1,
        name: this.productName
      }).then(res => {
        if (res.result) {
          // res.data.pList.map(it => {
          // 	it.checked = false;
          // })
          this.list = res.data.rows;
        }
      });
    },
    // 全选
    checkedAll() {
      let that = this;
      that.goodsId = [];
      if (!that.allCheck) {
        that.list.map(item => {
          that.$set(item, "checked", true);
          that.goodsId.push(item);
        });
      } else {
        that.list.map(item => {
          that.$set(item, "checked", false);
        });
      }
      that.allCheck = !that.allCheck;
    },
    // 单选
    checkedOne(item) {
      let that = this;
      that.$set(item, "checked", !item.checked);
      if (item.checked) {
        that.goodsId.push(item);
      } else {
        that.goodsId.map((v, index) => {
          if (v.id == item.id) {
            that.goodsId.splice(index, 1);
          }
        });
      }
      if (that.goodsId.length == 0) {
        that.allCheck = false;
      }
      if (that.goodsId.length == that.list.length) {
        that.allCheck = true;
      }
    },
    // 加入购物车
    addCart(item) {
      let that = this;
      let params = {
        obj: item.goods.uid
      };
      const routerJump = that.$router.resolve({
        name: "productDetails",
        path: "/productDetails",
        query: params
      });
      window.open(routerJump.href, "_blank");
    },
    // 删除所选
    allDelCllect() {
      let that = this;
      if (that.goodsId.length == 0) {
        message({
          message: "请选择需要删除的商品",
          type: "warning"
        });
        return;
      }
      that
        .$confirm(
          `确定删除${that.goodsId.length}件商品吗？`,
          "是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            center: true
          }
        )
        .then(() => {
          that.goodsId.map(item => {
            that.collectChange(item);
          });
          that.goodsId = [];
          that.list.map(item => {
            that.$set(item, "checked", false);
          });
        })
        .catch(() => {});
    },
    // 删除单个
    deleteItem(item) {
      let that = this;
      that
        .$confirm("确定删除该商品吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
        .then(() => {
          that.collectChange(item);
        })
        .catch(() => {});
    },
    // 删除收藏商品
    collectChange(item) {
      let that = this;
      const ids = [];
      ids.push(item.eshopGdGoodsTbl.id);
      goodsCollection({
        goodsIds: ids,
        type: 2
      }).then(res => {
        if (res.result) {
          that.getCollect();
          // that.list.map((it, index) => {
          // 	if (it.id == item.id) {
          // 		that.list.splice(index, 1);
          // 	}
          // })
        }
      });
    },
    // 重置
    reset() {
      this.date = "";
      this.suid = "";
      this.productName = ''
      this.getCollect();
    },
    confirm() {
      message({
        message: "功能暂未开放",
        type: "warning"
      });
    },
    goProductDetails(uid) {
      const routerJump = this.$router.resolve({
        path: "/productDetails",
        query: {
          obj: uid
        }
      });
      window.open(routerJump.href, "_blank");
    },
    clickDetails(item, type) {
      let params = {};
      params.uid = item.eshopGdGoodsTbl.uid;
      params.childrenName = item.eshopGdGoodsTbl.category.name;
      params.productId = item.eshopGdGoodsTbl.category.id;

      // 递归查找所有父级节点
      const findParents = (data, targetId, path = []) => {
        for (const item of data) {
          if (item.id === targetId) {
            return [...path, item];
          }
          if (item.children) {
            const result = findParents(item.children, targetId, [
              ...path,
              item
            ]);
            if (result) {
              return result;
            }
          }
        }
        return null;
      };

      // 查找匹配的节点及其所有父级
      const parents = findParents(this.categorys, params.productId);
      this.$store.commit("SET_CATEGORYDATA", parents);
      const routerJump = this.$router.resolve({
        name: "productTypeScreen",
        path: "/productTypeScreen",
        query: params
      });

      window.open(routerJump.href, "_blank");
    }
  }
};
</script>

<style scoped="scoped">
.el-select {
  width: 31.5%;
  height: 2.875rem;
  border-radius: 0.375rem;
}

.el-input {
  width: 31.5%;
  height: 2.875rem;
  border-radius: 0.375rem;
}

.el-range-editor.el-input__inner {
  width: 31.5%;
}

.user-page-box .user-lower-box .user-right .table tr th,
.user-page-box .user-lower-box .user-right .table tr td {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/userCenter/meCollection.vue